var map = {
	"./animazione_high.mp4": "1EVe",
	"./animazione_low.mp4": "T7zF",
	"./cucina_high.mp4": "MOOG",
	"./cucina_low.mp4": "s/QC",
	"./family_high.mp4": "8kJu",
	"./family_low.mp4": "eRbd",
	"./home_high.mp4": "ZgnP",
	"./home_low.mp4": "YoaJ",
	"./mare_high.mp4": "a4vv",
	"./mare_low.mp4": "oKbm",
	"./sport_high.mp4": "ceF7",
	"./sport_low.mp4": "L/Tw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qTiG";